export default __webpack_public_path__ + "static/media/sampleImportUser1.810669f2.png";